/**
 * SKIDAY ブランド設定（ビルド時用）
 *
 * 用途: skiday.html エントリポイントからビルド時に読み込まれる静的設定
 *
 * 注: ランタイムで動的にブランドを判断する場合は
 * frontend/src/config/brands.js の getBrandConfig() を使用
 */
export const brandConfig = {
  name: 'SKIDAY Desk',
  shortName: 'SKIDAY',
  tenantLabel: 'スキー場',
  tenantCollection: 'resorts',
  tenantIdField: 'resortId',
};
